export const ACTION_LOAD_FISCAL_NUMBER__REQUEST = 'ACTION_LOAD_FISCAL_NUMBER__REQUEST';
export const ACTION_LOAD_FISCAL_NUMBER__SUCCESS = 'ACTION_LOAD_FISCAL_NUMBER__SUCCESS';
export const ACTION_LOAD_FISCAL_NUMBER__FAIL = 'ACTION_LOAD_FISCAL_NUMBER__FAIL';

export const ACTION_EDIT_INDIVIDUAL_FISCAL_NUMBER__REQUEST = 'ACTION_EDIT_INDIVIDUAL_FISCAL_NUMBER__REQUEST';
export const ACTION_EDIT_INDIVIDUAL_FISCAL_NUMBER__SUCCESS = 'ACTION_EDIT_INDIVIDUAL_FISCAL_NUMBER__SUCCESS';
export const ACTION_EDIT_INDIVIDUAL_FISCAL_NUMBER__FAIL = 'ACTION_EDIT_INDIVIDUAL_FISCAL_NUMBER__FAIL';

export const ACTION_EDIT_CORPORATION_FISCAL_NUMBER__REQUEST = 'ACTION_EDIT_CORPORATION_FISCAL_NUMBER__REQUEST';
export const ACTION_EDIT_CORPORATION_FISCAL_NUMBER__SUCCESS = 'ACTION_EDIT_CORPORATION_FISCAL_NUMBER__SUCCESS';
export const ACTION_EDIT_CORPORATION_FISCAL_NUMBER__FAIL = 'ACTION_EDIT_CORPORATION_FISCAL_NUMBER__FAIL';
